import {Service} from "../interface/service";
import {TimelineLite, TweenLite} from "gsap";
import AbstractAnimation from "../animations/abstract-animation";

export class AnimationService implements Service {

    timeline: TimelineLite;

    run(target: any, $element: JQuery<HTMLElement>, options?: any, params?: any) {
        return new Promise((resolve) => {
            let object = <AbstractAnimation>Object.create(target.prototype);
            let instantiated = <AbstractAnimation>Object.create(target.prototype).constructor.apply(object, [$element, options, params]);
            instantiated.create();
            instantiated.run(() => resolve($element))
        });
    }

    clear = ($element: JQuery<HTMLElement>, options?: any) => TweenLite.set($element, Object.assign({clearProps: 'all'}, options));

    public clearTimeline = () => typeof this.timeline != 'undefined' && this.timeline.clear() && this.timeline.eventCallback('onComplete', null);

}